<template>
	<div class='feedback-wrap'>
		<div class="feedback-top">
			<div class="">
				<i class="el-icon-edit"></i>
				用户反馈
			</div>
		</div>
		<div class="form-wrap">
			<el-form ref="feedbackRef" label-width="80px" label-position="left" :model="formData">
				<el-form-item label="姓名" prop="realname" :rules="[
      { required: true, message: '请填写真实姓名', trigger: 'blur' }]">
					<el-input v-model=" formData.realname" placeholder="请填写真实姓名">
					</el-input>
				</el-form-item>
				<el-form-item label="电话" prop="phone" :rules="[
      { required: true, message: '请填写联系电话', trigger: 'blur' }]">
					<el-input v-model="formData.phone" placeholder="请填写联系电话，以便联系"></el-input>
				</el-form-item>
				<el-form-item prop="email" label="邮箱地址" :rules="[
      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
    ]">
					<el-input v-model="formData.email" placeholder="请填写电子邮箱地址，以便联系及回复"></el-input>
				</el-form-item>
				<el-form-item label="意见标题" prop="title" :rules="[
      { required: true, message: '请填写意见标题', trigger: 'blur' }]">
					<el-input v-model="formData.title" placeholder="请填写意见标题"></el-input>
				</el-form-item>
				<el-form-item label="意见内容" prop="content" :rules="[
      { required: true, message: '请提出您的宝贵意见', trigger: 'blur' }]">
					<el-input type="textarea" maxlength="300" show-word-limit :row="10" v-model="formData.content" placeholder="请提出您的宝贵意见"></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-button type="primary" class="red-button" @click="submitHandler">提交</el-button>
					<el-button type="warning" @click="resetHandler">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import { feedback } from '@/api';
export default {
	components: {},
	data() {
		return {
			formData: {}
		}
	},
	created() { },
	mounted() { },
	methods: {
		resetHandler() {
			this.$refs['feedbackRef'].resetFields()
		},
		submitHandler() {
			this.$refs['feedbackRef'].validate((valid) => {
				if (valid) {
					feedback(this.formData).then(res => {
						this.$message({
							message: '反馈成功',
							type: 'success'
						});
						this.resetHandler();
					})
				}
			})
		}
	},
	computed: {},
	watch: {},
}
</script>
<style lang='scss'>
	.feedback-wrap {
		width: 1280px;
		margin: 0 auto;
		padding: 20px 0;
		& > .feedback-top {
			width: 100%;
			padding-bottom: 20px;
			color: #6f7272;
			border-bottom: 2px solid #e1e8eb;
			text-align: left;
			font-weight: bold;
			font-size: 16px;
			i {
				font-size: 28px;
				color: $red;
				margin-right: 5px;
			}
		}
		& > .form-wrap {
			width: 860px;
			margin: 0 auto;
			padding: 20px 0;
			& > .el-form {
				width: 600px;
				margin: 0 auto;
				.el-input {
					.el-input__inner {
						font-size: 14px;
						height: 40px;
						border-radius: 3px;
						border-color: #efefef;
					}
				}
				.el-textarea {
					width: 500px;
					min-height: 150px;
					.el-textarea__inner {
						min-height: 150px !important;
						border-radius: 3px;
						border-color: #efefef;
					}
				}
				.el-button {
					width: 120px;
					margin: 0 20px;
					&.red-button {
						background-color: $red;
						border-color: $red;
					}
				}
			}
		}
	}
</style>
